/**
 * Data-export voor de dataweergave van de meetstandaard-onderzoekspagina
 * (superTenant): de brede, gepseudonimiseerde dataset zoals de tabel hem toont,
 * maar zonder de 200-rijen-pagina's — elke rij en elke zichtbare kolom.
 *
 * Nodig naast exportMsiResultsXlsx omdat die bewust alleen berekende
 * resultaten bevat. Besluit (user, 2026-10-12): onderzoekers moeten met de
 * data zelf kunnen rekenen. Spec: docs/features/supertenant-sector-correlations.md
 */
import * as XLSX from 'xlsx'

/**
 * Puur: bouwt het sheet-grid (array van rijen) voor de export.
 *
 * Twee kopregels: bovenaan het effect, daaronder de stelling — het effect
 * staat boven ELKE stelling (geen samengevoegde cel), zodat een kolom ook na
 * sorteren of verbergen zegt bij welk effect hij hoort. Besluit (user,
 * 2026-10-19); daarvóór stonden effect en stelling samen in één kop. Let op
 * bij SPSS/R: die lezen één kopregel, en dezelfde stelling kan onder twee
 * effecten staan. Scores ongerond; een ontbrekende score blijft een lege cel
 * (geen 0, geen streepje).
 *
 * @param {object} input
 * @param {Array<{key: string, effectName: string, itemTitle: string}>} input.columns - Zichtbare item-kolommen
 * @param {Array<{respondentLabel: string, orgName: string, momentLabel: string, scores: Object<string, number>}>} input.rows - Zichtbare rijen
 * @returns {Array<Array<*>>}
 */
export const buildMsiResearchDataSheet = ({ columns, rows }) => [
    ['', '', '', ...columns.map((column) => column.effectName)],
    ['Respondent', 'Organisatie', 'Meetmoment', ...columns.map((column) => column.itemTitle)],
    ...rows.map((row) => [
        row.respondentLabel,
        row.orgName,
        row.momentLabel,
        ...columns.map((column) => (Number.isFinite(row.scores[column.key]) ? row.scores[column.key] : '')),
    ]),
]

/**
 * Bouwt het xlsx-bestand en start de download.
 *
 * @param {object} input - Zelfde shape als buildMsiResearchDataSheet
 * @param {string} [fileName]
 */
const exportMsiResearchDataXlsx = (input, fileName = 'meetstandaard-data.xlsx') => {
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(buildMsiResearchDataSheet(input)), 'Data')
    XLSX.writeFile(workbook, fileName)
}

export default exportMsiResearchDataXlsx
